import Api from '@/services/Api'

export default {
  fetch () {
    return Api().get('websites')
  },

  add (params) {
    return Api().post('websites', params)
  },

  update (params) {
    return Api().put('websites/' + params.id, params)
  },

  get (params) {
    return Api().get('websites/' + params.id)
  },

  delete (id) {
    return Api().delete('websites/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/WebsitesService.js